export default function Solutions() {
  const solutions = [
    {
      icon: 'ri-flashlight-line',
      title: 'EnergyLoop',
      subtitle: 'Formerly BioLoop',
      description: 'Converts municipal sewage, industrial wastewater, and cluster housing wastewater into renewable electricity using advanced anaerobic digestion and biogas power generation systems.',
      features: [
        'Advanced anaerobic digestion',
        'Biogas power generation',
        'Municipal & industrial wastewater',
        'Renewable electricity production'
      ],
      color: 'emerald',
      image: 'https://public.readdy.ai/ai/img_res/83ae2bd82524f2e50d51bbbbbfc6b513.jpg'
    },
    {
      icon: 'ri-plant-line',
      title: 'FertiLoop',
      subtitle: 'Organic Fertiliser Production',
      description: 'Processes digestate from biogas systems into high-quality organic fertiliser used in agriculture, landscaping, and soil restoration.',
      features: [
        'High-quality organic fertiliser',
        'Agricultural applications',
        'Landscaping solutions',
        'Soil restoration products'
      ],
      color: 'amber',
      image: 'https://readdy.ai/api/search-image?query=Organic%20fertiliser%20production%20facility%20processing%20biogas%20digestate%20into%20nutrient-rich%20soil%20amendments%2C%20showing%20clean%20industrial%20equipment%2C%20storage%20silos%2C%20and%20quality%20control%20systems%20in%20African%20agricultural%20setting%20with%20bright%20natural%20lighting%20and%20simple%20background%20emphasizing%20sustainable%20agriculture%20and%20circular%20economy%20fertiliser%20manufacturing&width=600&height=400&seq=fertiloop-organic&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'WaterLoop',
      subtitle: 'Water Recovery & Purification',
      description: 'Recovers and purifies wastewater for industrial, agricultural, and non-potable reuse, reducing water scarcity and improving water security.',
      features: [
        'Industrial water reuse',
        'Agricultural irrigation',
        'Non-potable applications',
        'Water security solutions'
      ],
      color: 'blue',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20water%20purification%20and%20recovery%20facility%20with%20filtration%20systems%20and%20treatment%20tanks%20processing%20wastewater%20for%20reuse%20in%20African%20industrial%20setting%2C%20featuring%20modern%20water%20treatment%20technology%2C%20clean%20pipelines%2C%20monitoring%20equipment%2C%20under%20bright%20daylight%20with%20simple%20background%20highlighting%20water%20conservation%20and%20recycling%20infrastructure&width=600&height=400&seq=waterloop-recovery&orientation=landscape'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'VentureLoop',
      subtitle: 'Circular Infrastructure Investment',
      description: 'Kagesi\'s investment platform designed to mobilize blended finance for wastewater-to-value projects, structuring investments from DFIs, climate funds, impact investors, and commercial financiers.',
      features: [
        'Blended finance structuring',
        'DFI partnerships',
        'Climate fund mobilization',
        'Bankable project development'
      ],
      color: 'green',
      image: 'https://readdy.ai/api/search-image?query=Professional%20investment%20and%20finance%20meeting%20with%20diverse%20stakeholders%20reviewing%20circular%20economy%20infrastructure%20projects%2C%20modern%20African%20office%20setting%20with%20financial%20charts%2C%20sustainability%20metrics%2C%20and%20digital%20presentations%2C%20bright%20natural%20lighting%20with%20clean%20minimalist%20background%20emphasizing%20climate%20finance%20and%20impact%20investment%20collaboration&width=600&height=400&seq=ventureloop-investment&orientation=landscape'
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            What We Do
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Integrated <strong>Wastewater-to-Value</strong> Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Four core platforms that transform waste streams into clean energy, climate-smart fertilisers, reclaimed water, and bankable infrastructure projects.
          </p>
        </div>

        <div className="space-y-12">
          {solutions.map((solution, index) => (
            <div 
              key={index} 
              className={`bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } flex flex-col lg:flex`}
            >
              <div className="lg:w-1/2 p-10 flex flex-col justify-center">
                <div className={`w-14 h-14 bg-${solution.color}-100 rounded-xl flex items-center justify-center mb-6`}>
                  <i className={`${solution.icon} text-${solution.color}-600 text-2xl`}></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{solution.title}</h3>
                <p className="text-sm text-gray-500 mb-4">{solution.subtitle}</p>
                <p className="text-gray-600 mb-6 leading-relaxed">{solution.description}</p>
                <div className="grid grid-cols-2 gap-3">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <i className={`ri-checkbox-circle-fill text-${solution.color}-600 text-lg flex-shrink-0 mt-0.5`}></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:w-1/2 relative h-80 lg:h-auto">
                <img 
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}